module.exports = __webpack_public_path__ + "static/blue_grren1-c65839e649e63134e0c3d3c3121107d5.png";